import { isDevSessionRequestUrl } from '@/lib/auth';
import type { InternalAxiosRequestConfig } from 'axios';

function normalizeBaseUrl(url: string): string {
  return url.replace(/\/+$/, '');
}

/** True when the request targets the encrypted game API (not admin, not dev-session). */
export function isGameApiRequest(
  config: InternalAxiosRequestConfig,
  gameBaseUrl: string,
  adminBaseUrl: string,
): boolean {
  if (isDevSessionRequestUrl(config.url)) {
    return false;
  }
  const base = normalizeBaseUrl(config.baseURL ?? gameBaseUrl);
  if (base === normalizeBaseUrl(adminBaseUrl)) {
    return false;
  }
  const path = (config.url ?? '').toLowerCase();
  if (path.includes('/admin/')) {
    return false;
  }
  return true;
}
